import axiosInstance from './axiosInstance';

const usersApi = {
  getAll: params => axiosInstance.get('/users', { params }).then(r => r.data),
  getById: id => axiosInstance.get(`/users/${id}`).then(r => r.data),
  create: data => axiosInstance.post('/users/register', data).then(r => r.data),
  uploadAvatar: (id, formData) => axiosInstance.post(`/users/${id}/avatar`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data),
  changeRole: (id, role) => axiosInstance.patch(`/users/${id}/role`, { role }).then(r => r.data),
  deactivate: id => axiosInstance.patch(`/users/${id}/deactivate`).then(r => r.data)
};

export default usersApi;
